<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZCpNHe/images/cover.jpg?1685327317466" alt="This image is the cover for the book Another Way, Another Way..."/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Another Way, Another Way...
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>An Another Way... Story</i></b></p><p>On the surface, Jesse Ross is an average guy in an average relationship with his college sweetheart, Adele. But what his girlfriend doesn’t know is that he’s having an affair—with a man—and exploring his sexuality in ways she never could imagine. His compartmentalized life suits Jesse just fine, and he has no intention of coming out of the closet either as a bisexual or as a submissive.</p> <p>However, Jesse takes a tumble when his Master, Will, admits to wanting more, wanting Jesse as his partner, not just his submissive. Suddenly Jesse's conveniently pieced-together life isn’t quite so comfortable. In the end, Jesse has to lay it all on the line—for his girlfriend, for his lover, and for himself.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anna Martin
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d21917b